module.exports = __webpack_public_path__ + "c64938c9546460552a5f8a179bfd29ee.png";